import { createContext } from "react";
import type { MyPayEnvironment } from "../../generated/core-api";
import type { ComponentMatchingImportManagerReturn } from "../hooks/useComponentMatchingImportInvocation";
import type {
  BoundPayRun,
  MatchingParseError,
  MatchingRow,
} from "../types/matching";
export interface MatchingWizardContextValue {
  companyCode: string;
  companyName: string;
  mypayEnvironment: MyPayEnvironment;
  boundPayRun: BoundPayRun | null;
  fileName: string | null;
  rawCsvText: string | null;
  parsedRows: MatchingRow[] | null;
  parseErrors: MatchingParseError[];
  failedUploadAttempt: {
    fileName: string;
    rawCsvText: string | null;
    parseErrors: MatchingParseError[];
  } | null;
  manager: ComponentMatchingImportManagerReturn;
  setUploadSuccess: (fileName: string, rawCsvText: string, rows: MatchingRow[]) => void;
  /**
   * Row-level parse failure: keep CSV rows (incl. stubs) for the report table,
   * clear any prior validate/commit batch, and queue parsable rows for
   * validate/commit (partial import).
   */
  setUploadParseFailure: (
    fileName: string,
    rawCsvText: string,
    rows: MatchingRow[],
    errors: MatchingParseError[]
  ) => void;
  updateParsedRows: (rows: MatchingRow[]) => void;
  setFailedUploadAttempt: (
    attempt: {
      fileName: string;
      rawCsvText: string | null;
      parseErrors: MatchingParseError[];
    } | null
  ) => void;
  clearUpload: () => void;
}

export const MatchingWizardCtx =
  createContext<MatchingWizardContextValue | null>(null);
